import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationsApi } from '../../api/lib/destinations';
import { destinationsKeys } from '../../api/query-keys/destinations';
import { Destination } from '../../api/types/destination';

export const useDestination = (id: number) => {
  return useQuery<Destination, ApiError>({
    queryKey: destinationsKeys.detail(id),
    queryFn: () => destinationsApi.fetchDestination(id),
  });
};
